import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { InstancesRoutingModule } from './instance-routing.module';
import { IonicModule } from '@ionic/angular';
import { InstancePage } from './instance.page';
import { UpdateInstanceComponent } from './update-instance/update-instance.component';
import { SharedModule } from '../shared/shared.module';
import { AddInstanceComponent } from './add-instance/add-instance.component';
import { InstanceDetailsComponent } from './instance-details/instance-details.component';



@NgModule({
  declarations: [
    InstancePage,
    AddInstanceComponent,
    InstanceDetailsComponent,
    UpdateInstanceComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InstancesRoutingModule,
    IonicModule,
    SharedModule
  ]
})
export class InstancesModule { }
